<template>
  <div id="app" class="contents-body">
    <Slide>
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
      <router-link to="/contact">Contact</router-link>
    </Slide>
    <main role="main">
      <transition name="router-transition">
        <router-view/>
      </transition>
    </main>
    <footer>
      <p class="copyright">
        © 2018- 株式会社未来演算研究所
      </p>
    </footer>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
  name: 'App',
  components: {
    Slide
  }
}
</script>

<style lang="scss">
$color-main: #232323;
$color-base: #fff;
$color-accent: #ED1C24;
$color-text: $color-main;
$color-link: $color-accent;
$header-height: 60px;
$footer-height: 60px;

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, "メイリオ", Meiryo, Arial, sans-serif;
  font-feature-settings: "palt";
  font-size: 14pt;
}

#app {
  height: 100%;
  background-color: $color-base;
  background: url('./assets/background.svg') !important;
  background-position: center center !important;
  background-size: cover !important;
  color: $color-text;
}

a {
  color: $color-link;
}

h1, h2, h3, h4, h5, h6 {
  color: $color-accent;
}

main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  background: radial-gradient(ellipse, rgba(255,255,255,1) 0%, rgba(255,255,255,0.95) 25%, rgba(255,255,255,0) 100%);
}

#sideNav {
  .bm-item-list {
    margin: 0;
  }
  a {
    font-family: "Roboto", sans-serif;
    color: #bdc3c7;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    &:link, &:visited {
      position: relative;
      display: block;
      padding: 14px 15px;
      font-size:14px;
      font-weight: bold;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
      overflow: hidden;
      letter-spacing: .08em;
      border-radius: 0;
      text-shadow: 0 0 1px rgba(0, 0, 0, 0.2), 0 1px 0 rgba(0, 0, 0, 0.2);
      transition: all 1s ease;
      &:after {
        content: "";
        position: absolute;
        height: 0%;
        left: 50%;
        top: 50%;
        width: 150%;
        z-index: -1;
        transition: all 0.75s ease 0s;
      }
      &:hover {
        color: hsl(358, 85%, 52%);
        border-top: 2px solid hsl(358, 85%, 52%);
        border-bottom: 2px solid hsl(358, 85%, 52%);
        text-shadow: none;
        &:after {
          height: 450%;
        }
      }
    }
    &:after {
      opacity: 0;
      background-image: linear-gradient(transparent 50%, rgba(255, 255, 255, 0.2) 50%);
      background-size: 10px 10px;
      transform: translateX(-50%) translateY(-50%) rotate(25deg);
    }
    &:hover:after {
      height: 600% !important;
      opacity: 1;
      color: hsl(358, 85%, 52%);
    }
  }
  .bm-cross-button {
    &.cross-style {
      right: 12px;
      .bm-cross {
        left: 10px;
        height: 24px !important;
      }
    }
  }
}
.bm-burger-button {
  z-index: 999;
}

footer {
  height: $footer-height;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  .copyright {
    font-size: 0.5rem;
  }
}

.router-transition-enter-active {
  animation: fadeIn 1s;
  animation-delay: .5s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.router-transition-leave-active {
  animation: fadeOut .5s;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.page-wrap {
  position: relative;
}
.page {
  position: fixed;
  width: inherit;
}

::-webkit-scrollbar {
  width: 0.5em;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
</style>



// WEBPACK FOOTER //
// src/App.vue